import type { Locale } from '../locales'
import { translatorFor, type TranslateWith } from '../translate'
import { ca } from './ca'
import { en } from './en'
import { es, type BackOfficeCatalog, type BackOfficeMessageKey } from './es'

/*
 * The back office web's catalog (ADR 0008 §2): its own Vite entry imports this module, never
 * the portal's catalog (`@eklevo/shared/i18n`), so neither bundle carries the other's texts.
 */

export * from '../locales'
export type { MessageValues } from '../translate'
export type { BackOfficeCatalog, BackOfficeMessageKey }

export const backOfficeCatalogs: Record<Locale, BackOfficeCatalog> = { es, ca, en }

export type BackOfficeTranslate = TranslateWith<BackOfficeMessageKey>

export function createBackOfficeTranslator(locale: Locale): BackOfficeTranslate {
  return translatorFor(backOfficeCatalogs[locale], locale)
}
